import Form from "./Form";
import React from "react";
import { useAppContext } from "./AppContext";
import { useTakebackConfig } from "./TakebackConfigContext";
import { useBrand } from "./BrandContext";

function DetailsForm() {
  const {
    handleSubmitTakeback,
    userDetails,
    setUserDetails,
    userDetailsHasErrors,
    setUserDetailsHasErrors,
    createTakebackError,
    setCreateTakebackError,
    takebackMutationLoading,
    takebackId,
    emailInputLabel,
  } = useAppContext();
  const { name, collectAgeAndGender } = useBrand();

  const { tsAndCsLabelOverride } = useTakebackConfig();

  const handleChange = (newValue) => {
    const updatedDetails = { ...userDetails, ...newValue };
    setUserDetails(updatedDetails);
    setUserDetailsHasErrors(false);
    setCreateTakebackError(false);
  };

  const ageAndGenderFields = {
    type: "double_select",
    fields: [
      {
        name: "ageGroup",
        value: userDetails.ageGroup.value,
        type: "select",
        label: "Age group",
        options: [
          ["16-24", "16-24"],
          ["25-34", "25-34"],
          ["35-44", "35-44"],
          ["45-54", "45-54"],
          ["55-64", "55-64"],
          ["65+", "65+"],
        ],
        error: userDetails.ageGroup.error,
      },
      {
        name: "gender",
        value: userDetails.gender.value,
        type: "select",
        label: "Gender",
        options: [
          ["male", "Male"],
          ["female", "Female"],
          ["prefer_not_to_say", "Prefer not to say"],
        ],
        error: userDetails.gender.error,
      },
    ],
    explaination:
      "As part of this programme it is useful for us to understand our audience so that we can improve the experience for all",
  };

  const formFields = [
    {
      name: "email",
      value: userDetails.email.value,
      placeholder: "Enter email",
      type: "email",
      label: emailInputLabel,
      autoComplete: "email",
      error: userDetails.email.error,
    },
    {
      type: "form_field_group",
      fields: [
        {
          name: "confirmEmail",
          value: userDetails.confirmEmail.value,
          placeholder: "Confirm email",
          type: "email",
          label: "So we know we've got the right address",
          autoComplete: "email",
          error: userDetails.confirmEmail.error,
        },
        {
          name: "optOutReskinned",
          value: userDetails.optOutReskinned.value,
          type: "checkbox",
          label: "Don't send me Reskinned updates and offers",
          error: userDetails.optOutReskinned.error,
        },
        {
          name: "optInBrand",
          value: userDetails.optInBrand.value,
          type: "checkbox",
          label: `I agree that you can pass my details to ${name} so that they can send me updates and offers`,
          error: userDetails.optInBrand.error,
        },
      ],
    },
    {
      name: "postcode",
      postcodeValue: userDetails.postcode.value,
      postcodeError: userDetails.postcode.error,
      courierServiceValue: userDetails.courierServiceId.value,
      courierServiceError: userDetails.courierServiceId.error,
      labelTypeValue: userDetails.labelType.value,
      labelTypeError: userDetails.labelType.error,
      placeholder: "Postcode",
      type: "courier_service_finder",
      label: "Enter your postcode to find your nearest drop point.",
      autoComplete: "postal-code",
    },
    {
      name: "mobileNumber",
      value: userDetails.mobileNumber.value,
      placeholder: "Enter mobile",
      type: "tel",
      label:
        "Enter your mobile so we can text you updates or call if there are any issues.",
      autoComplete: "tel",
      error: userDetails.mobileNumber.error,
    },
    {
      name: "terms",
      value: userDetails.terms.value,
      type: "checkbox",
      label:
        tsAndCsLabelOverride ||
        "I accept the <a href='https://www.reskinned.clothing/pages/takeback/takeback-terms-and-conditions' target='_blank' style='text-decoration: underline;'>terms and conditions</a> and I acknowledge that I have read the <a href='https://www.reskinned.clothing/legal/privacy-notice' target='_blank'  style='text-decoration: underline;'>privacy policy.</a>",
      error: userDetails.terms.error,
    },
  ];

  if (collectAgeAndGender) {
    formFields.splice(2, 0, ageAndGenderFields);
  }

  let error = null;
  if (createTakebackError)
    error = "Something went wrong, takeback could not be created";
  if (userDetailsHasErrors)
    error = "Could not submit, please check the form above";

  return (
    <Form
      fields={formFields}
      handleChange={handleChange}
      handleSubmit={handleSubmitTakeback}
      error={error}
      submitting={takebackMutationLoading || takebackId !== null}
    />
  );
}

export default DetailsForm;
